// 引入通用common
import {mapGetters, mapMutations} from 'vuex';
import * as types from '@/store/types';

export default {
  data() {
    return {
      imgUrl:process.env.FILE_DOMAIN
    }
  },
  computed: {
    ...mapGetters({
      localUser: types.GET_LOCALUSER,
      localCart: types.GET_LOCALCART
    })
  },
  methods: {
    // 书本变量初始化mutation
    ...mapMutations({
      saveLocaluserFun: types.SAVE_LOCALUSER,
      saveLocalcartFun: types.SAVE_LOCALCART
    }),
    toBack() {
      let httpHost = this.localUser.httpHost;
      window.location = httpHost;
    }
  },
  components: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
  }
};



// WEBPACK FOOTER //
// ./src/util/mix/general.js